/*
  CUSTOM: Stock Indicator Bar – Variant-Change-Refresh

  Warum dieses Script noetig ist:
  Dawn's renderProductInfo() (assets/global.js) aktualisiert bei Variant-Wechsel nur
  eine feste Liste von Elementen (price-/Sku-/Inventory-/Volume-/ProductSubmitButton-
  {section}). Unsere Bar ist nicht dabei, wuerde also auf dem alten Wert stehenbleiben.

  Dawn publiziert am Ende des Refreshs PUB_SUB_EVENTS.variantChange mit dem kompletten
  neuen HTML. Wir subscriben uns darauf, ziehen die frisch gerenderte Bar raus und
  tauschen die alte. Dabei merken wir die alte Breite, setzen sie initial auf das
  neue Element und animieren per CSS-Transition auf die neue Ziel-Breite.

  Enthaelt KEINE Geschaeftslogik (Schwellwerte/Texte kommen vollstaendig aus Liquid).
*/

(function () {
  'use strict';
  if (window.__egStockBarInit) return;
  window.__egStockBarInit = true;

  var WRAP_ID = 'eg-stock-indicator-wrap';

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // pubsub.js / constants.js noch nicht geladen – kurz warten
      window.setTimeout(init, 50);
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.html) return;

      var newDoc = event.data.html;
      var newWrap = newDoc.getElementById(WRAP_ID);
      var currentWrap = document.getElementById(WRAP_ID);
      if (!newWrap || !currentWrap) return;

      // Alte Breite merken, bevor wir den Inhalt austauschen
      var oldBar = currentWrap.querySelector('.progress-bar');
      var oldWidth = null;
      if (oldBar) {
        oldWidth = oldBar.style.width || window.getComputedStyle(oldBar).width;
      }

      // Inneren Inhalt ersetzen (alte Bar raus, neue mit korrektem Text/Farbe/Breite rein)
      currentWrap.innerHTML = newWrap.innerHTML;

      // Von alter auf neue Breite animieren
      if (oldWidth) {
        var newBar = currentWrap.querySelector('.progress-bar');
        if (newBar && newBar.dataset.width) {
          var targetWidth = newBar.style.width || newBar.dataset.width;
          newBar.style.transition = 'none';
          newBar.style.width = oldWidth;
          // Reflow erzwingen, damit der Browser die Start-Breite uebernimmt
          void newBar.offsetWidth;
          newBar.style.transition = 'width 0.6s ease';
          newBar.style.width = targetWidth;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
